import { HttpClient } from '@angular/common/http';
// https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=YOUR_API_KEY
import { Injectable, OnDestroy } from '@angular/core';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

import { LogService } from '../../helpers/log.service';
@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService implements OnDestroy {
  private readonly apiUrl = environment.geoCoordinatesUrl;
  private readonly mapsApiKey = 'AIzaSyCl9WHRbl1FdeKyaVtOoebHiGOBNcba53k';

  public isGoogleMapsLoaded = this.lazyLoadGoogleMapsJavascript();

  constructor(
    private httpClient: HttpClient,
    private logService: LogService
  ) {}

  ngOnDestroy() {}

  GeocodeFromAddress(address: string) {
    console.log('GoogleMapsService.GeocodeFromAddress()');
    return this.httpClient.get<any>(this.apiUrl, {
      params: {
        address,
      },
    });
  }

  CityFromGeocode(geocode: any) {
    return this.httpClient.get<any>(this.apiUrl, {
      params: {
        address: `${geocode.coords.latitude}, ${geocode.coords.longitude}`,
      },
    });
  }

  private lazyLoadGoogleMapsJavascript() {
    return this.httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=' + this.mapsApiKey, 'callback').pipe(
      map((obj) => {
        this.logService.success('Google Map successfully lazy loaded!', obj);
        return true;
      }),
      catchError((err) => {
        this.logService.danger('error loading Google Map: ', err);
        return of(false);
      }),
      shareReplay(1)
    );
  }
}
